import loadable from '@loadable/component';

export const ArticleSearchHeroLoadable = loadable(
  () => import('./ArticleSearchHero'),
  { resolveComponent: (module) => module.ArticleSearchHero },
);
